import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../auth/auth.service';
import { EnvironmentService } from '../../../services/environment.service';

@Component({
  selector: 'app-landing-header',
  templateUrl: './landing-header.component.html'
})
export class LandingHeaderComponent implements OnInit {

  public store: string;
  constructor(
    private authService: AuthService,
    private envService: EnvironmentService
  ) {

  }

  ngOnInit() {
    this.store = this.envService.getStore();
  }
  /**
   * Purpose: For redirecting to TID Login Screen if Login Button is clicked
   */
  public loadLoginPage() {
    this.authService.login();
  }
}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/modules/header/landing-header/landing-header.component.ts